export default "__VITE_ASSET__CYTGeIVZ__"